import React from 'react'
import theme from 'theme'
import Icon from 'assets/icons/Icon'

const PageModeSwitcher = ({ showInstruction, togglePageMode, t }) => {
  return (
    <div
      style={{
        position: 'absolute',
        right: 0,
        fontSize: '18px',
        bottom: 0,
        cursor: 'pointer',
        color: showInstruction ? theme.gray : theme.white,
        display: 'flex',
      }}
      onClick={togglePageMode}
    >
      {showInstruction ? (
        <Icon name="arrowRight" width={11} height={18} className="arrowInstruction" stroke={theme.gray} />
      ) : (
        <Icon name="arrowLeft" width={11} height={18} className="arrowInstruction" stroke={theme.white} />
      )}
      <div style={{ marginLeft: '15px', lineHeight: '21px' }}>{t('instruction')}</div>
    </div>
  )
}

export default PageModeSwitcher
